import axios from '@axios';

export default {
	namespaced: true,
	state: {},
	getters: {},
	mutations: {},
	actions: {
		fetchRequestInformation(ctx, { id }) {
			return new Promise((resolve, reject) => {
				axios
					.get(`/request-information/${id}/edit`)
					.then(response => resolve(response))
					.catch(error => reject(error));
			});
		},
	}
}